/**
 * Procedure Categories and Procedures for MD / Diploma in Pulmonary Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 3-4: "Performance and interpretation" & "Therapeutic procedures")
 */
export const PULMONARY_PROCEDURES = {
  "Diagnostic Tests & Procedures": [
    "Sputum Collection & ZN Staining for Acid-Fast Bacilli (AFB)",
    "Sputum & Body Fluids Examination (ZN Stain, Culture for Bacteria/Fungi)",
    "Fine Needle Aspiration Cytology (FNAC) of Lung Masses (Blind & Image-Guided)",
    "Arterial Blood Gas (ABG) Analysis & Pulse Oximetry",
    "Sputum Cytology",
    "Polysomnography (Full-Night & Split-Night Studies) & CPAP Titration",
    "Cardiopulmonary Exercise Testing",
    "Pulmonary Function Testing (Spirometry, Lung Volumes, Diffusions, Body Plethysmography)",
    "Bronchoprovocation Testing",
    "BCG Vaccination",
    "Mantoux Testing & Interferon Gamma Release Assays (IGRA)",
    "Fibreoptic / Rigid Bronchoscopy (Diagnostic & Therapeutic)",
    "Skin Tests for Hypersensitivity",
    "Sputum Induction & Non-Invasive Monitoring of Airway Inflammation",
    "Medical Thoracoscopy",
  ],
  "Therapeutic & Emergency Procedures": [
    "Fine Needle Aspiration & Image-Guided Aspiration Procedures",
    "Tube Thoracostomy (Intercostal Drainage / ICD Tube Insertion)",
    "Cardiopulmonary Rehabilitation Exercises",
    "Postural Drainage",
    "Pleural Biopsy & Lymph Node Biopsy",
    "Administration of Inhalation Therapy",
    "Administration of Oxygen Therapy",
    "Administration of Non-Invasive Ventilation (CPAP / BiPAP)",
    "Monitoring & Emergency Procedures in Intensive Care",
  ],
};

export const PULMONARY_CATEGORIES = Object.keys(PULMONARY_PROCEDURES);

export const isDiplomaInPulmonaryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("pulmonary") ||
    d.includes("chest") ||
    d.includes("tb and chest") ||
    d.includes("respiratory")
  );
};

